import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiHome, FiBox, FiFileText, FiCpu } from 'react-icons/fi';

const screens = [
  {
    icon: <FiHome />,
    label: 'Bosh sahifa',
    className: 'screen-home',
    title: 'Home',
    desc: "Barcha loyihalar, takliflar va tezkor qidiruv bir joyda.",
  },
  {
    icon: <FiBox />,
    label: '3D ko\'rinish',
    className: 'screen-3d',
    title: '3D View',
    desc: "Kvartira ichini 360° interaktiv ko'rinishda o'rganing.",
  },
  {
    icon: <FiFileText />,
    label: 'Shartnoma',
    className: 'screen-contract',
    title: 'Shartnoma',
    desc: "5 bosqichda onlayn shartnoma tuzing va imzolang.",
  },
  {
    icon: <FiCpu />,
    label: 'AI Chat',
    className: 'screen-ai',
    title: 'AI Chat',
    desc: "Sun'iy intellekt yordamchisi bilan suhbatlashing.",
  },
];

const AppScreenshots = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.12 } },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  return (
    <section className="screenshots-section section-container" id="screenshots" ref={ref}>
      <div className="screenshots-header">
        <span className="section-tag">Ilova</span>
        <h2 className="section-title">
          Ilova ichidan <span className="gold-text">ko'rinish</span>
        </h2>
        <p className="section-desc">
          OSTONA ilovasining asosiy ekranlarini ko'ring va imkoniyatlar bilan tanishing.
        </p>
      </div>

      <motion.div
        className="screenshots-grid"
        variants={container}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
      >
        {screens.map((s, i) => (
          <motion.div className="screenshot-item" key={i} variants={item}>
            <div className="screenshot-phone">
              <div className={`screenshot-phone-inner ${s.className}`}>
                <div className="screenshot-phone-icon">{s.icon}</div>
                <span className="screenshot-phone-label">{s.label}</span>
                <div className="screenshot-phone-bars">
                  <div className="screenshot-phone-bar" />
                  <div className="screenshot-phone-bar" />
                  <div className="screenshot-phone-bar" />
                </div>
              </div>
            </div>
            <h3 className="screenshot-title">{s.title}</h3>
            <p className="screenshot-desc">{s.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default AppScreenshots;
